package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.data.RefRange
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesEnglish
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesHebrew
import com.eladfinish.bible.contest.domain.BooksRepository.numOfChaptersPerBook
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.VerseReferenceCV
import com.eladfinish.bible.contest.utils.gematriaWord

class GetSederContentUseCase(
    private val getContentUseCase: GetContentUseCase,
) {

    operator fun invoke(
        refRange: RefRange?,
        onlyQri: Boolean,
    ): String {
        refRange ?: return ""
        val content = StringBuilder()

        val bookNameStart = refRange.start.book
        val bookNameEnd = refRange.end.book

        val startBookIndex = bookNamesHebrew.indexOf(bookNameStart)
        val endBookIndex = bookNamesHebrew.indexOf(bookNameEnd)

        val startChapter = refRange.start.chapter.gematriaWord()
        val startVerse = refRange.start.verse.gematriaWord()

        val endChapter = refRange.end.chapter.gematriaWord()
        val endVerse = refRange.end.verse.gematriaWord()

        // מקרה 1 — הכל בתוך ספר אחד
        if (startBookIndex == endBookIndex) {
            val pickedBookEng = bookNamesEnglish[startBookIndex]

            for (chapter in startChapter..endChapter) {
                content.append(
                    getContentUseCase.getContent(
                        bookIndex = startBookIndex.fileIndex,
                        bookName = pickedBookEng,
                        currentChapter = chapter,
                        startVerseReferenceCV = VerseReferenceCV(startChapter, startVerse),
                        endVerseReferenceCV = VerseReferenceCV(endChapter, endVerse),
                        onlyQri = onlyQri,
                    )
                ).append("\n")
            }

            return content.toString().trim()
        }

        // מקרה 2 — סדר פרוס על פני כמה ספרים
        for (bookIndex in startBookIndex..endBookIndex) {

            val bookNameEng = bookNamesEnglish[bookIndex]
            val chaptersInBook = numOfChaptersPerBook[bookIndex]

            val chapterStart =
                if (bookIndex == startBookIndex) startChapter else 1

            val chapterEnd =
                if (bookIndex == endBookIndex) endChapter else chaptersInBook

            for (chapter in chapterStart..chapterEnd) {

                val startVerseForCall =
                    if (bookIndex == startBookIndex && chapter == startChapter) {
                        startVerse
                    } else {
                        1 // מעבר לפרק חדש או ספר חדש → מתחילים מפסוק 1
                    }

                val endVerseForCall =
                    if (bookIndex == endBookIndex && chapter == endChapter) {
                        endVerse
                    } else {
                        999 // ערך גדול שלא יחתוך שום דבר בפועל
                    }

                content.append(
                    getContentUseCase.getContent(
                        bookIndex = bookIndex.fileIndex,
                        bookName = bookNameEng,
                        currentChapter = chapter,
                        startVerseReferenceCV = VerseReferenceCV(chapter, startVerseForCall),
                        endVerseReferenceCV = VerseReferenceCV(chapter, endVerseForCall),
                        onlyQri = onlyQri,
                    )
                ).append("\n")
            }
        }

        return content.toString().trim()
    }

}

private val Int.fileIndex: Int
    get() = this + 1
